import { Fragment, useContext, useState, useEffect } from "react";
import { api } from "../..";
import { AppContext } from '../../AppContext';
import { app } from "@microsoft/teams-js";
import { setCookie } from "typescript-cookie";
import { isBeta, portalDomain } from "../../Constants";

const domain = isBeta ? portalDomain.beta : portalDomain.production

const Wallboard = (props: any) => {
	app.initialize()
	const user = api.getUser();
	const appContext = useContext(AppContext);
	const themeType = appContext.themeType === 'dark' ? 'dark' : 'light';
	const [url, setUrl] = useState(`https://teams.microsoft.com/l/entity/5c45da75-72df-474c-9b59-6ed5dc1a31e7/adminportalConfMonitors?webUrl=${domain}/company/${user.pbx_company_id}/user/${user.id}/wallboards/wallboard/${props.id}?wallboard_token=${props.token}&isTeams=1&theme=${themeType}`);

	useEffect(() => {
		app.getContext().then((context) => {
			if(Object.keys(context).length !== 0) {
				if(api.isLoggedIn() && props.id && window.location.pathname === '/settings') {
					setUrl(`https://teams.microsoft.com/l/entity/5c45da75-72df-474c-9b59-6ed5dc1a31e7/adminportalConfMonitors`);
				}
			}
		});
		// eslint-disable-next-line
	}, [])

	const urlData = () => {
		setCookie('wallboardId', String(props.id), { secure: true, sameSite: 'None', path: '/' })
		app.openLink(url);
	}

	return <Fragment>
		<a
			href={url}
			rel="noreferrer"
			className="button"
			onClick={urlData}
		>
			{props.name}
		</a>
	</Fragment>
}

export default Wallboard
